import type { ConsignmentsUrlState } from '../model/types';

export const DEFAULT_URL_STATE: ConsignmentsUrlState = {
  size: '20',
  sortField: 'cmrNumber',
  sortDirection: 'asc',
  requestNumber: '',
  status: '',
  period: 'L6M',
  creationDateFrom: '',
  creationDateTo: '',
  orgId: '',
  waybill: '',
  q: '',
  allSites: 'false'
};
